import { NgModule } from '@angular/core';
import { AuthGuard } from './helpers';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@environments/environment';

const routes: Routes = [
  {
    path: 'forms', data: { title: 'Contratos - ' + environment.prefix_title },
    loadChildren: () => import('./forms-contracts/forms-contracts.module').then(m => m.FormsContractsModule)
  },
  {
    path: 'iFrame', data: { title: 'Uploads - ' + environment.prefix_title },
    loadChildren: () => import('./admin/upload-files-sf-iframe/upload-files-sf-iframe.module').then(m => m.UploadFilesSfIframeModule)
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./insystem/insystem.module').then(m => m.InsystemModule) },
  {
    path: 'sessions', data: { title: 'Inicio de sesión - ' + environment.prefix_title },
    loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
